<script setup lang="ts">
/**
 *
 *  Props and emits section
 *
 *
 */

export interface HomeBreadCrumbItem {
    name: string
    route?: string
    isCurrent?: boolean
}

defineProps<{
    items: HomeBreadCrumbItem[]
}>()

/**
 *
 *  Ref, computed and hooks section
 *
 *
 */

/**
 *
 *  Life cicle events
 *
 *
 */

/**
 *
 *  Functions section
 *
 *
 */
</script>

<template>
    <div class="tw-w-full tw-bg-primary">
        <div
            class="max-container tw-min-h-[60px] tw-flex tw-gap-2 tw-justify-center tw-items-center tw-font-medium"
        >
            <template v-for="(item, i) in items" :key="i">
                <span v-if="i !== 0" class="tw-text-white">/</span>
                <span v-if="item.isCurrent" class="tw-text-white tw-flex">
                    <span>{{ item.name }}</span>
                </span>
                <span
                    v-else-if="!item.route"
                    class="tw-text-primary-200 tw-flex"
                >
                    <span>{{ item.name }}</span>
                </span>
                <NuxtLink
                    v-else
                    :to="item.route || '/'"
                    class="tw-text-primary-200 tw-flex"
                >
                    <span>{{ item.name }}</span>
                </NuxtLink>
            </template>
        </div>
    </div>
</template>
